import { motion } from 'framer-motion'
import { StyleContentWrapper } from '@pages/front/commons/ContentWrapper/style'
import { StyledContactUsBannerWrapper } from './style'
import { overLappingImage } from '@assets/icons'
import { StyleText } from '@pages/front/commons/Text/style'
import Button from '@components/button'
import { useNavigate } from 'react-router-dom'

const MotionStyledContactUsBannerWrapper = motion(StyledContactUsBannerWrapper)
const MotionStyleText = motion(StyleText)
const MotionButton = motion(Button)

const ContactUsBanner = () => {
  const navigate = useNavigate()

  return (
    <StyleContentWrapper paddingLeft="60" paddingRight="60">
      <MotionStyledContactUsBannerWrapper
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.9, delay: 0.3 }}
          dangerouslySetInnerHTML={{ __html: overLappingImage }}
        />

        <MotionStyleText
          color="#0f1828"
          fontSize="18"
          centered
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.9, delay: 0.4 }}
        >
          Still have questions?
        </MotionStyleText>

        <MotionStyleText
          color="#414146"
          weight="300"
          centered
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.9, delay: 0.5 }}
        >
          Can't find the answer you're looking for? Please chat to our friendly
          team.
        </MotionStyleText>

        <MotionButton
          title="Contact Us"
          onClick={() => navigate('/contact-us')}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.9, delay: 0.6 }}
        />
      </MotionStyledContactUsBannerWrapper>
    </StyleContentWrapper>
  )
}

export default ContactUsBanner
